import type { SYSAction } from "../../../../../../../_ovlclient/src"
import type {
  HookFieldGetList_ReturnType,
  HookFieldGetList_Type,
  HookFormChanged_Type,
  HookFormValidate_Type,
} from "../../../../../../../_ovlclient/src/global/hooks"
import {
  FieldIsValid,
  FieldSetState,
  FieldSetVal,
  FieldVal,
} from "../../../../../../../_ovlclient/src/library/forms/fieldapi"
import { _validationsAdd } from "../../../../../../../_ovlclient/src/library/forms/validators"
import {
  ValidationSummaryRemove,
  ValidationsAdd,
} from "../../../../../../../_ovlclient/src/library/forms/validatorsapi"
import { NewServiceStep2FormFieldKeys } from "./formdef"

const HookFormChanged: SYSAction<HookFormChanged_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  let changedField = value.changedField
  let formState = value.formState
  let initiatedByFormInit = value.initiatedByFormInit

  let newService = state.app.global.SVL.NewService

  if (!initiatedByFormInit) {
    if (
      changedField.field.fieldKey.indexOf("objectLocation") > -1 &&
      changedField.field.fieldKey !== "objectLocationConfirmed"
    ) {
      FieldSetState(formState.fields["objectLocationConfirmed"], false, {
        animate: "fade",
      })
      ValidationSummaryRemove(formState, "NewServiceValidationAddressHelpLink")
    }

    if (changedField.isValid) {
      if (changedField.field.fieldKey === "objectLocationConfirmed") {
        FieldSetState(changedField.field, false, { animate: "fade" })
      }
      if (changedField.field.fieldKey === "requesterType") {
        newService.contact.cardGroup = changedField.newValue
        let additionalContactNeeded =
          changedField.newValue &&
          state.app.global.SVL.lookups.cardGroup.data[changedField.newValue][
            "CardType"
          ] === "2"

        FieldSetState(
          value.formState.fields["requesterFirstName"],
          !newService.contact.id
        )
        FieldSetState(
          value.formState.fields["requesterLastName"],
          !newService.contact.id
        )

        FieldSetState(
          value.formState.fields["requesterCFirstName"],
          additionalContactNeeded
        )
        FieldSetState(
          value.formState.fields["requesterCLastName"],
          additionalContactNeeded
        )
        FieldSetState(
          value.formState.fields["requesterCPhone"],
          additionalContactNeeded
        )
        FieldSetState(
          value.formState.fields["requesterCEmail"],
          additionalContactNeeded
        )
      }
    }
  }

  let cardGroup = newService.contact.cardGroup
  let requesterType = formState.fields["requesterType"]
  if (initiatedByFormInit) {
    if (cardGroup) {
      FieldSetVal(requesterType, cardGroup, { forceChanged: true })
    } else {
      FieldSetVal(requesterType, "105", { forceChanged: true })
    }
  }
}

const HookFormValidate: SYSAction<HookFormValidate_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  let fieldKey = <NewServiceStep2FormFieldKeys>value.field.fieldKey
  let field = value.formState.fields[fieldKey]
  switch (fieldKey) {
    case "objectLocationZipCode":
    case "objectLocationCity":
      let zipCodeField = value.formState.fields["objectLocationZipCode"]
      let cityField = value.formState.fields["objectLocationCity"]
      let zipCodeIsValid = isValidSwissPLZ(
        FieldVal(zipCodeField, { mode: "RawCurrent" })
      )
      let cityFieldValue = FieldVal(cityField, { mode: "RawCurrent" })
      let cityIsValid = cityFieldValue && cityFieldValue.length > 2
      if (!(zipCodeIsValid || cityIsValid)) {
        value.validationsAdd("NewServiceValidationPLZOrCity", {
          fields: [zipCodeField, cityField],
          validation: {
            summaryDisplayType: "WhenAllRelatedFieldsTouched",
            summaryGroup: "ValidationKey",
          },
        })
      }

      break

    case "objectLocationStreet":
      value.validatorUse("Mandatory")

      break

    case "objectLocationNr":
      value.validatorUse("Mandatory")
      if (FieldIsValid(field) && field.convertedValue.length > 1) {
        if (value.newValue !== " ") {
          let regex = /([\s0-9]{1,4}\s*)([a-zA-Z]?)/
          let res = value.newValue.match(regex)
          if (res && res.length > 0) {
            value.setCorrectedValue(res[1].trim() + res[2])
          } else {
            value.validationsAdd("NewServiceValidationInvalidStreetNo")
          }
        }
      }

      break
      // case "objectLocationConfirmed":
      //   value.validatorUse("MandatoryCheck", { val: true })
      break

    case "requesterFirstName":
    case "requesterLastName":
    case "requesterType":
      value.validatorUse("Mandatory")
      break

    case "requesterCFirstName":
    case "requesterCLastName":
      value.validatorUse("Mandatory")
      break
    case "requesterCEmail":
      value.validatorUse("Mandatory")
      if (FieldIsValid(field)) {
        value.validatorUse("Email")
      }
      break
    case "requesterCPhone":
      value.validatorUse("Mandatory")
      if (FieldIsValid(field)) {
        let matches = value.newValue.toString().match(/\d+/g)
        let parsed
        let valid = true
        if (matches && matches.length > 0) {
          parsed = matches.join("")
          if (parsed.length < 10) {
            valid = false
          }
        } else {
          valid = false
        }
        if (!valid) {
          value.validationsAdd("NewServiceValidationInvalidPhone")
        }
      }

      break
  }
}

const HookField_requesterType_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  return state.app.global.SVL.lookups.cardGroup
}

const isValidSwissPLZ = (plz: string) => {
  if (!plz) {
    return false
  }
  let plzNum = parseInt(plz.toString())
  if (Number.isNaN(plzNum)) {
    return false
  }
  if (plzNum.toString().length !== 4) {
    return false
  }
  return true
}

export let hooks = {
  HookFormChanged,
  HookFormValidate,
  HookField_requesterType_GetList,
}
